import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import { CartProvider } from './context/CartContext';
import { Layout } from './components/layout/Layout';
// Pages
import { HomePage } from './pages/HomePage';
import { ProductListingPage } from './pages/ProductListingPage';
import { ProductDetailPage } from './pages/ProductDetailPage';
import { CartPage } from './pages/CartPage';
import { CheckoutPage } from './pages/CheckoutPage';
import { OrderConfirmationPage } from './pages/OrderConfirmationPage';
import { PaymentPage } from './pages/PaymentPage';
import { LoginPage } from './pages/LoginPage';
import { RegisterPage } from './pages/RegisterPage';
import { AccountPage } from './pages/AccountPage';
import { ContactPage } from './pages/ContactPage';
import { AboutPage } from './pages/AboutPage';
import { FAQPage } from './pages/FAQPage';
import { AdminDashboard } from './pages/admin/AdminDashboard';
export function App() {
  return <Router data-id="element-0">
      <AuthProvider data-id="element-1">
        <CartProvider data-id="element-2">
          <Routes data-id="element-3">
            {/* Admin Routes (No Main Layout) */}
            <Route path="/admin" element={<AdminDashboard data-id="element-5" />} data-id="element-4" />
            <Route path="/admin/*" element={<AdminDashboard data-id="element-7" />} data-id="element-6" />

            {/* Auth Routes (No Main Layout) */}
            <Route path="/login" element={<LoginPage data-id="element-9" />} data-id="element-8" />
            <Route path="/register" element={<RegisterPage data-id="element-11" />} data-id="element-10" />

            {/* Paysys Labs Payment Gateway (No Main Layout) */}
            <Route path="/payment" element={<PaymentPage data-id="element-13" />} data-id="element-12" />

            {/* Main App Routes (With Layout) */}
            <Route path="*" element={<Layout data-id="element-15">
                  <Routes data-id="element-16">
                    <Route path="/" element={<HomePage data-id="element-18" />} data-id="element-17" />
                    <Route path="/products" element={<ProductListingPage data-id="element-20" />} data-id="element-19" />
                    <Route path="/product/:slug" element={<ProductDetailPage data-id="element-22" />} data-id="element-21" />
                    <Route path="/cart" element={<CartPage data-id="element-24" />} data-id="element-23" />
                    <Route path="/checkout" element={<CheckoutPage data-id="element-26" />} data-id="element-25" />
                    <Route path="/order-confirmation" element={<OrderConfirmationPage data-id="element-28" />} data-id="element-27" />
                    <Route path="/account/*" element={<AccountPage data-id="element-30" />} data-id="element-29" />
                    <Route path="/contact" element={<ContactPage data-id="element-32" />} data-id="element-31" />
                    <Route path="/about" element={<AboutPage data-id="element-34" />} data-id="element-33" />
                    <Route path="/faq" element={<FAQPage data-id="element-36" />} data-id="element-35" />
                    <Route path="/wishlist" element={<Navigate to="/account" replace data-id="element-38" />} data-id="element-37" />
                    <Route path="*" element={<Navigate to="/" replace data-id="element-40" />} data-id="element-39" />
                  </Routes>
                </Layout>} data-id="element-14" />
          </Routes>
        </CartProvider>
      </AuthProvider>
    </Router>;
}